// client-overview translations (Spanish catalog).
window.PlummeI18n.register('es', {
  'kov.chip.search': 'Búsqueda: {query}',
  'kov.chip.vatLiable': 'Sujeto a IVA: {value}',
  'kov.chip.hasEmployees': 'Tiene empleados: {value}',
  'kov.searchClient': 'Buscar cliente',
  'kov.responsible': 'Responsable',
  'kov.allResponsible': 'Todos los responsables',
  'kov.status': 'Estado',
  'kov.allStatuses': 'Todos los estados',
  'kov.onlyActionNeeded': 'Mostrar solo clientes que requieren acción',
  'kov.moreFilters': 'Más filtros',
  'kov.resetFilters': 'Restablecer filtros',
  'kov.deadline': 'Plazo',
  'kov.allDeadlines': 'Todos los plazos',
  'kov.next7Days': 'Próximos 7 días',
  'kov.companyType': 'Forma jurídica',
  'kov.all': 'Todos',
  'kov.yes': 'Sí',
  'kov.no': 'No',
  'kov.vatLiable': 'Sujeto a IVA',
  'kov.hasEmployees': 'Tiene empleados',
  'kov.title': 'Resumen de clientes',
  'kov.subtitle': 'Consulta qué requiere seguimiento en todos tus clientes.',
  'kov.myClients': 'Mis clientes',
  'kov.allClients': 'Todos los clientes',
  'kov.refresh': 'Actualizar',
  'kov.emptyTitle': 'Aún no hay clientes',
  'kov.emptyText': 'Los clientes aparecerán aquí en cuanto acepten el encargo. Envía una solicitud desde Clientes, en Otros.',
  'kov.kpi.needsAction': 'Requiere acción',
  'kov.kpi.waitingForCustomer': 'Esperando al cliente',
  'kov.kpi.deadline7': 'Plazo en los próximos 7 días',
  'kov.kpi.deadlinePassed': 'Plazo vencido',
  'kov.kpi.readyForReview': 'Listo para revisión',
  'kov.kpi.needsActionHelp': 'Cuenta clientes únicos, no el número de avisos.',
  'kov.showing': 'Mostrando:',
  'kov.removeFilter': 'Quitar filtro',
  'kov.sortBy': 'Ordenar por',
  'kov.noMatchTitle': 'Ningún cliente coincide con los filtros',
  'kov.noMatchText': 'Prueba a cambiar la búsqueda o restablece los filtros.',
});
